class Logo {
    constructor(logoSvgElement) {
        this.logo = logoSvgElement;

        this.strip1 = new Part(this.logo.children[0], 10);
        this.strip2 = new Part(this.logo.children[1], 7.5);
        this.strip3 = new Part(this.logo.children[2], 5);
        this.m = new Part(this.logo.children[3], 27.5);
        this.t = new Part(this.logo.children[4], 22.5);
        this.l = new Part(this.logo.children[5], 15);

        this.gap = 2.5;
        this.position = "123...";

        this.bindEvents();
        this.move(1, 1, 1);
    }

    bindEvents() {
        this.logo.addEventListener("mouseover", this.stop.bind(this));
        this.logo.addEventListener("mouseout", this.play.bind(this));
    }

    destroy() {
        this.stop();
        this.logo.removeEventListener("mouseover", this.stop.bind(this));
        this.logo.removeEventListener("mouseout", this.play.bind(this));
    }

    stop() {
        clearTimeout(this.timeout);
        this.move(1, 1, 1);
    }

    play() {
        this.timeout = setTimeout(() => this.shake(), 2000);
    }

    shake() {
        let positions = [
            '123...'  , // ▊ ▌ ▎M T L
            '12.3..'  , // ▊ ▌ M ▎ T L
            '12..3.'  , // ▊ ▌ M T ▎ L
            '12...3'  , // ▊ ▌ M T L ▎
            '1.23..'  , // ▊ M ▌ ▎ T L
            '1.2.3.'  , // ▊ M ▌ T ▎ L
            '1.2..3'  , // ▊ M ▌ T L ▎
            '1..23.'  , // ▊ M T ▌ ▎ L
            '1..2.3'  , // ▊ M T ▌ L ▎
            '1...23'  , // ▊ M T L ▌ ▎
            '.123..'  , // M ▊ ▌ ▎ T L
            '.12.3.'  , // M ▊ ▌ T ▎ L
            '.12..3'  , // M ▊ ▌ T L ▎
            '.1.23.'  , // M ▊ T ▌ ▎ L
            '.1..23'  , // M ▊ T L ▌ ▎
            '..123.'  , // M T ▊ ▌ ▎ L
            '..12.3'  , // M T ▊ ▌ L ▎
            '..1.23'  , // M T ▊ L ▌ ▎
            '...123'  , // M T L ▊ ▌ ▎
        ];

        // Evito di avere una posizione uguale alla precedente
        let position;
        do {
            position = positions[this.random(0, 11)];
        } while (position === this.position);

        this.position = position;

        // Converto
        let strip1Pos, strip2Pos, strip3Pos;
        position.split(".").forEach((position, index) => {
            if (position.includes("1")) {
                strip1Pos = index + 1;
            }

            if (position.includes("2")) {
                strip2Pos = index + 1;
            }

            if (position.includes("3")) {
                strip3Pos = index + 1;
            }
        });

        this.move(
            strip1Pos,
            strip2Pos,
            strip3Pos,
            () => this.play()
        );
    }

    move(strip1Pos, strip2Pos, strip3Pos, onComplete) {
        let sectors = [[], [this.m], [], [this.t], [], [this.l], []];

        sectors[(strip1Pos - 1) * 2].push(this.strip1);
        sectors[(strip2Pos - 1) * 2].push(this.strip2);
        sectors[(strip3Pos - 1) * 2].push(this.strip3);

        let x = 0;
        sectors.forEach(parts => {
            parts.forEach(part => {
                part.element.style.transform = `translateX(${x}%)`;
                x += part.width + this.gap;
            });
        });

        if (onComplete) {
            onComplete();
        }
    }

    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}

class Part {
    constructor(element, width) {
        this.element = element;
        this.width = width;
    }
}

export default class LogoWebComponent extends HTMLElement {
    static observedAttributes = ["stopped"];

    constructor() {
        super();

        this.innerHTML = `<svg viewBox="0 0 240 42" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 0H0V42H24V0Z"/></g><g><path d="M18 0H0V42H18V0Z"/></g><g><path d="M12 0H0V42H12V0Z"/></g><g><path d="M66 0H60V42H66V0Z"/><path d="M54 0H60L39 42L33 42L54 0Z"/><path d="M12 0H6L27 42L33 42L12 0Z"/><path d="M6 0H0V42H6V0Z"/></g><g><path d="M30 6H24V42H30V6Z"/><path d="M54 0H0V6H54V0Z"/></g><g><path d="M36 36H6V42H36V36Z"/><path d="M6 0H0V42H6V0Z"/></g></svg>`;

        this.logo = new Logo(this.querySelector("svg"));
    }

    connectedCallback() {
        if (typeof this.getAttribute("stopped") !== "string") {
            this.play();
        }
    }

    disconnectedCallback() {
        this.logo.destroy();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "stopped") {
            if (typeof newValue === "string") {
                this.stop();
            } else {
                this.play();
            }
        }
    }

    play() {
        this.logo.play();
    }

    stop() {
        this.logo.stop();
    }

    isStopped() {
        return typeof this.getAttribute("stopped") === "string";
    }
}
